import {eTipoPermissao} from '@/enums/ePermissoes';
export default [
 {
  description: 'Motivo de Baixa',
  path: '/patrimonio/patmotivobaixa',
  name: 'patmotivobaixa',
  component: () => import('@/views/patrimonio/patmotivobaixa/Index.vue'),
  meta: {
   permissions: [eTipoPermissao.MOTIVODEBAIXANOVO_MENU_1200300499],
  },
  goesToMenu: true,
 },
 {
  description: 'Cadastro de Motivo de Baixa',
  path: '/patrimonio/patmotivobaixa/cadastro/:id?',
  parent: 'patmotivobaixa',
  name: 'patmotivobaixa_create',
  component: () => import('@/views/patrimonio/patmotivobaixa/InclusaoEdicao.vue'),
  meta: {
   permissions: [eTipoPermissao.MOTIVODEBAIXANOVO_MENU_1200300499],
  },
  goesToMenu: true,
 },
]
